<span class="loader" [attr.size]="size" [attr.color]="color"></span>
